import { Component, OnInit } from '@angular/core';
import { ProjectDetailInstance } from '../project-detail.instance';
import { ProjectService } from '../../project.service';

@Component({
  selector: 'cw-project-detail-api',
  templateUrl: './project-detail-api.component.html',
  styleUrls: ['./project-detail-api.component.scss']
})
export class ProjectDetailApiComponent implements OnInit {
  response: any;

  constructor(private instance: ProjectDetailInstance,
              private projectService: ProjectService) {
    this.instance.$project.subscribe(project => {
      if (project) {
        this.loadFeed();
      }
    });
  }

  ngOnInit() {
  }

  private loadFeed() {
    this.projectService.getPublic(this.instance.project.id).subscribe(r => {
      this.response = r;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-api/project-detail-api.component.ts